<template>
  <component :is="element" class="venueName">{{venueName}}</component>
</template>

<script>

export default {
  props: {
    element: {
      type: String,
      default: 'p',
      required: false
    },
    venue: {
      type: Object,
      required: false
    },
    name: {
      type: String,
      required: false
    }
  },

  computed: {
    venueName () {
      if (this.venue) {
        return this.venue.name
      } else if (this.name) {
        return this.name
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
.venueName {
  @include font('040');

  text-transform: none;
  margin: 0;

  @include font('040')
}
</style>
